// extracted by mini-css-extract-plugin
export default {"cls1":"Page-cls1_xaa","cls2":"Page-cls2_zSe Page-cls1_xaa"};